import { BaseOneServiceI18n } from '@soluto-private/mx-i18n';
import { useCallback } from 'react';
import { useI18n } from './i18nClient';

export type TranslateParameters = Parameters<BaseOneServiceI18n['get']>;

export const useTranslation = () => {
  const i18n = useI18n();

  return useCallback(
    (...args: TranslateParameters) => i18n?.get(...args) ?? '',
    [i18n]
  );
};
